import { Maybe, Timestamp, TODO } from '@b2b/types/core';
import uiRouter from '@uirouter/angularjs';
import angular, { IScope, ITimeoutService } from 'angular';
import { SubscriptionsListServiceModule } from './SubscriptionsList.service';

SubscriptionsListEndDatePickerController.$inject = [
  '$scope',
  '$timeout',
  'UserPreferencesService',
  'SubscriptionsListService',
];

function SubscriptionsListEndDatePickerController(
  $scope: IScope & { subscriptionsListDatePicker: any; dt: Maybe<Date>; minDate: Maybe<Date> },
  $timeout: ITimeoutService,
  UserPreferencesService: any,
  SubscriptionsListService: any
) {
  const ctrl = {
    isOpen: false,
    dt: null as Maybe<Date>,

    dateOptions: {
      formatYear: 'yy',
      startingDay: UserPreferencesService.getStartDayOfWeek(),
      formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat'),
      showWeeks: false,
      minDate: null,
    } as {
      formatYear: 'yy';
      startingDay: number;
      formatDayTitle: TODO;
      showWeeks?: boolean;
      minDate?: Maybe<Timestamp>;
    },
    isPreferenceLoaded: false,
    init: function () {
      $scope.$on('UserPreferencesService:onDateFormatLoad', ctrl.onDateFormatLoad);
      $timeout(function () {
        ctrl.isPreferenceLoaded = true;
      }, 0);
    },

    today: function () {
      ctrl.dt = new Date();
    },
    clear: function () {
      $scope.dt = null;
    },

    toggleMin: function () {
      $scope.minDate = $scope.minDate ? null : new Date();
    },

    open: function ($event) {
      $event.preventDefault();
      $event.stopPropagation();

      ctrl.dateOptions.minDate = SubscriptionsListService.getStartDate();

      ctrl.isOpen = true;
    },

    onDateFormatLoad: function (e, data) {
      ctrl.dateOptions = {
        formatYear: 'yy',
        startingDay: UserPreferencesService.getStartDayOfWeek(),
        formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat'),
      };
    },
  };

  $scope.subscriptionsListDatePicker = ctrl;
  ctrl.init();
}

export const SubscriptionsListEndDatePickerControllerModule = angular
  .module('acme.view.application.subscriptions.list.endDatePicker.controllers', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.userPreferences',
    SubscriptionsListServiceModule,
  ])
  .controller('SubscriptionsListEndDatePickerController', SubscriptionsListEndDatePickerController).name;
